import { FC, ReactNode } from "react";
import styles from "./Popup.module.scss";
import { PageTitleBlock } from "../PageTitleBlock/PageTitleBlock";

export interface IPopupProps {
    onClose: () => void;
}

interface ICustomPopupProps extends IPopupProps {
    title: string;
    description: ReactNode;
    icon: string;
    footer?: ReactNode;
}

export const Popup: FC<ICustomPopupProps> = ({ title, description, icon, onClose, footer }) => {
    return (
        <div className={styles.popup}>
            <div className={styles.contentWrapper}>
                <img
                    src={ icon }
                    alt="icon"
                    className={styles.icon}
                />

                <PageTitleBlock
                    pageDescription={ description }
                    pageTitle={ title }
                />

                {footer ?? (
                    <button className={styles.closeButton} onClick={onClose}>
                        Закрыть
                    </button>
                )}
            </div>
        </div>
    );
};
